<footer class="" role="contentinfo">
  <div class="">
    <nav>
      <ul class="list-group list-group-horizontal">
        <li class="list-group-item pb-0"><a title="Contact us">Contact</a></li>
        <li class="list-group-item pb-0"><a title="Privacy policy">Privacy policy</a></li>
      </ul>
    </nav>
    <!-- Todo: Make the year below dynamic -->
    <p class="mb-0">Copyright &copy; 2024 Built by Brian Worsham.
    <p>Site: Version 1.0 | Last Updated on March 6th 2023, 11:13 pm CST.</p>
  </div>
  <!-- todo: add a linkedIn icon and github icon to link to my accounts -->
</footer>
